exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-319b7c32] .link_val{margin-bottom:15px}\n", ""]);

// exports
